import { CommonModule } from '@angular/common';
import { ChangeDetectionStrategy, Component, input, output } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { ButtonModule } from 'primeng/button';
import { DialogModule } from 'primeng/dialog';
import { IftaLabelModule } from 'primeng/iftalabel';
import { InputGroupModule } from 'primeng/inputgroup';
import { InputGroupAddonModule } from 'primeng/inputgroupaddon';
import { TextareaModule } from 'primeng/textarea';

@Component({
    selector: 'app-delivery-cancellation-dialog',
    standalone: true,
    templateUrl: './delivery-cancellation-dialog.component.html',
    changeDetection: ChangeDetectionStrategy.OnPush,
    imports: [CommonModule, FormsModule, ButtonModule, DialogModule, IftaLabelModule, InputGroupModule, InputGroupAddonModule, TextareaModule]
})
export class DeliveryCancellationDialogComponent {
    readonly visible = input(false);
    readonly deliveryNumber = input<string | undefined>();
    readonly reason = input('');
    readonly saving = input(false);
    readonly visibleChange = output<boolean>();
    readonly reasonChange = output<string>();
    readonly confirmed = output<void>();
}
